import React, { useEffect } from 'react'
import Tilt from 'react-parallax-tilt'

const Celebration: React.FC = () => {
	useEffect(() => {
		let container = document.querySelector('#root') as HTMLDivElement
		let mover = document.querySelector('#spec') as HTMLImageElement

		if (container && mover) {
			container.addEventListener('mousemove', function (e) {
				// console.log(e)
				let val = -e.offsetX / 20
				// console.log(val)

				// mover.style.transform = `scale(1.2), translateX(${val}px)`
				// mover.style.transform = `translateX(${val}px)`
			})
		}
	}, [])

	return (
		<div className='celebration--container'>
			<Tilt
				tiltReverse={true}
				tiltAxis='y'
				glareEnable={false}
				transitionEasing={'ease-out'}
				transitionSpeed={200}
				trackOnWindow={true}
				tiltMaxAngleY={8}
			>
				<div className='celebration--image' id='spec-main'>
					<img src='/images/celebration/top.png' alt='' />
					{/* <img id='spec' src='/images/celebration/main.png' alt='' /> */}
					<div></div>
					<img src='/images/celebration/bottom.png' alt='' />
				</div>
			</Tilt>

			<div className='celebration--content'>
				<h2>A wonder in woman form, An example to follow in life and in the faith.</h2>
				<p>Join us as we celebrate our mommy, a huge example of a follower & a submitted wife.</p>
				<a href='https://gratico.app/mummy-lillian' className='btn-join-celebration'>
					Send your greetings{' '}
					<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M4.16669 9.99996H15.8334M15.8334 9.99996L10 4.16663M15.8334 9.99996L10 15.8333'
							stroke='#101828'
							strokeWidth='2'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
					</svg>
				</a>
			</div>
		</div>
	)
}

export default Celebration
